import { render, staticRenderFns } from "./FaqPages.vue?vue&type=template&id=695ffc9d&scoped=true&"
import script from "./FaqPages.vue?vue&type=script&lang=js&"
export * from "./FaqPages.vue?vue&type=script&lang=js&"
import style0 from "./FaqPages.vue?vue&type=style&index=0&id=695ffc9d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695ffc9d",
  null
  
)

export default component.exports